<template>
  <div class="filter-container">

    <a-input
        name="file-name"
        id="file-name"
        v-model="query"
        @keyup.enter="onInput"
        @input="onInput"
        type="text"
        placeholder="Bestandsnaam..."
        title="Bestandsnaam"
        autocomplete="off"
        spellcheck="false"
        data-lpignore="true"
        style="width: 200px;"
        allowClear
    />

    <users-select
        :value="filter.createdByUser"
        @change="setFilterCreatedByUser($event)"
        style="min-width: 200px; max-width: 220px"
        appendCssClass="small"
        name="users-select"
        title="Behandelaar"
    />

    <a-select
        mode="multiple"
        :default-value="[]"
        :locale="locale"
        style="min-width: 200px;"
        placeholder="Bestandstype"
        title="Bestandstype"
        @change="setFilterMimeType($event)"
        allowClear
    >
      <a-select-option value="image">
        <file-image-icon class="iconColor"/>
        Afbeelding
      </a-select-option>
      <a-select-option value="email">
        <at-icon class="email"/>
        Email
      </a-select-option>
      <a-select-option value="excel">
        <file-excel-icon class="excel"/>
        Excel
      </a-select-option>
      <a-select-option value="generic">
        <file-icon class="iconColor"/>
        Generiek
      </a-select-option>
      <a-select-option value="outlook">
        <email-lock-icon class="outlook"/>
        Outlook
      </a-select-option>
      <a-select-option value="pdf">
        <file-pdf-icon class="pdf"/>
        Pdf
      </a-select-option>
      <a-select-option value="word">
        <file-word-icon class="word"/>
        Word
      </a-select-option>
    </a-select>

    <a-range-picker
        @change="setFilterDateRange"
        :format="dateFormatEnum.DISPLAY_DATE"
        :placeholder="['Startdatum', 'Einddatum']"
        :ranges="{
          'Vorige maand': [
              moment().subtract(1, 'months').startOf('month'),
              moment().subtract(1, 'months').endOf('month')
            ],
          'Deze maand': [
              moment().startOf('month'),
              moment().endOf('month')
            ],
         }"
        :default-picker-value="[moment().subtract(1, 'months'), moment()]"
        style="width: 230px"
        title="Periode"
    >
      <a-icon slot="suffixIcon" type="calendar"/>
    </a-range-picker>

  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/nl_NL';
import moment from 'moment';
import {DateFormatEnum} from "~/enums/";


export default {
  name: "AttachableOverviewFilterComponent",
  data() {
    return {
      locale,
      filter: {
        createdByUser: [],
        dateRange: [],
        mimeType: [],
        fileName: '',
      },
      dateFormatEnum: DateFormatEnum,
      query: '',
    }
  },
  methods: {
    moment,
    setFilterCreatedByUser(value) {
      this.filter.createdByUser = []; // clear
      Object.assign(this.filter.createdByUser, value); // set
      this.filterRequest();
    },
    setFilterMimeType(value) {
      this.filter.mimeType = value;
      this.filterRequest();
    },
    setFilterDateRange(date) {
      this.filter.dateRange = [];
      if (date.length) {
        this.filter.dateRange[0] = date[0].startOf('day').format('YYYY-MM-DD HH:mm:ss');
        this.filter.dateRange[1] = date[1].endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      this.filterRequest();
    },
    onInput() {
      this.filter.fileName = this.query.trim();
      this.debounce(() => this.filterRequest())();
    },
    debounce(func, timeout = 400) {
      return (...args) => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          func.apply(this, args);
        }, timeout);
      };
    },
    filterRequest() {
      this.$emit('filter-request', this.filter);
    },
  },
}
</script>

<style scoped>
.iconColor {
  color: #000000a6;
}

.word {
  color: #00a2ed;
}

.emailDocument {
  color: #0072C6;
}

.outlook {
  color: #0072C6;
}

.excel {
  color: #1D6F42;
}

.pdf {
  color: #F40F02;
}

.email {
  color: #0072C6;
}

.filter-container {
  display: flex;
  gap: 1em;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
}
</style>
